import {
  CreateTaskGroupDto,
  TaskGroupDto,
  taskGroupsHttp,
  UpdateTaskGroupDto,
} from '@/core';
import { api } from '../api';
import { rtkq, RtkqRequest } from '../rtkq';

export type CreateTaskGroupArgs = CreateTaskGroupDto;
export type UpdateTaskGroupArgs = UpdateTaskGroupDto;
export type TaskGroupState = TaskGroupDto;

const taskGroupsApi = api.injectEndpoints({
  endpoints: (build) => {
    return {
      addTaskGroup: build.mutation<string, RtkqRequest<CreateTaskGroupArgs>>({
        queryFn: (args) => {
          return rtkq(args).exec(() => taskGroupsHttp.create(args));
        },
        invalidatesTags: () => [
          { type: 'task-group', id: 'list' },
          { type: 'task', id: 'list' },
        ],
      }),

      updateTaskGroup: build.mutation<string, RtkqRequest<UpdateTaskGroupArgs>>(
        {
          queryFn: (args) => {
            return rtkq(args).exec(() => taskGroupsHttp.update(args));
          },
          invalidatesTags: () => [
            { type: 'task-group', id: 'list' },
            { type: 'task', id: 'list' },
          ],
        },
      ),

      ungroupTasks: build.mutation<string, RtkqRequest<{ groupId: string }>>({
        queryFn: (args) => {
          return rtkq(args).exec(() => taskGroupsHttp.ungroup(args));
        },
        invalidatesTags: () => [
          { type: 'task-group', id: 'list' },
          { type: 'task', id: 'list' },
        ],
      }),

      getTaskGroup: build.query<TaskGroupState, RtkqRequest<{ id: string }>>({
        queryFn: async (args) => {
          const { id } = args;
          return rtkq(args).exec(() => taskGroupsHttp.get(id));
        },
        providesTags: (group) => [
          { type: 'task-group', id: group?.id ?? 'none' },
        ],
      }),

      getTaskGroupsList: build.query<
        TaskGroupState[],
        RtkqRequest<{ projectId: string }>
      >({
        queryFn: async (args) => {
          const { projectId } = args;
          return rtkq(args).exec(() => taskGroupsHttp.getAll(projectId));
        },
        providesTags: (_) => [{ type: 'task-group', id: 'list' }],
      }),
    };
  },
});

export const {
  useAddTaskGroupMutation,
  useUngroupTasksMutation,
  useUpdateTaskGroupMutation,
  useGetTaskGroupQuery,
  useLazyGetTaskGroupsListQuery,
} = taskGroupsApi;
